// EE-216: recognising the server's refusal to close a late QC step.
//
// ProductionController raises DelayReasonRequiredError, which the API returns
// as a 422 whose plain-text body starts with the DELAY_REASON_REQUIRED code.
// The code is matched rather than the prose so the message can be reworded
// without breaking this. Reachable whenever the dialog was bypassed - the QC
// task can also be closed from Project Management and the custom-task button.
export const DELAY_REASON_REQUIRED_CODE = "DELAY_REASON_REQUIRED";

export const isDelayReasonRequired = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : `${error ?? ""}`;
  return message.includes(DELAY_REASON_REQUIRED_CODE);
};
